var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3204 3.59961C14.6004 3.60233 12.9891 4.46031 12.0004 5.89965C11.0116 4.46031 9.40039 3.60233 7.68039 3.59961C4.86758 3.59961 2.40039 6.27614 2.40039 9.32693C2.40039 12.3002 4.04195 15.3625 7.14789 18.183C8.58695 19.4873 10.1655 20.6211 11.8535 21.5632C11.9457 21.6118 12.0551 21.6118 12.1473 21.5632C13.8346 20.6211 15.4127 19.4872 16.8513 18.183C19.9588 15.3625 21.6004 12.3002 21.6004 9.32693C21.6004 6.27614 19.1332 3.59961 16.3204 3.59961Z",
    fill: "#F93749"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconRed);
export default __webpack_public_path__ + "static/media/heart-icon-red.575202dcbca7a748ff3485f440cc0ef5.svg";
export { ForwardRef as ReactComponent };